// A single frontend build serves both the .de and .ch domains. Stripe is split
// into one account per country, so the publishable key and every price ID must
// be picked from the domain the user is currently on: .ch -> Swiss account,
// everything else -> German account.

export interface PointsPackage {
  id?: string
  amount?: string
  points?: string
}

const isSwissDomain = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname.endsWith('.ch')

const pick = (deValue?: string, chValue?: string): string =>
  (isSwissDomain() ? chValue : deValue) ?? ''

export const getSubscriptionYearPriceId = (): string =>
  pick(
    process.env.REACT_APP_PRICE_SUBSCRIPTION_YEAR,
    process.env.REACT_APP_PRICE_SUBSCRIPTION_YEAR_CH
  )

export const getPointsPackages = (): PointsPackage[] =>
  isSwissDomain()
    ? [
        {
          id: process.env.REACT_APP_PRICE_POINTS_FIRST_CH,
          amount: process.env.REACT_APP_AMOUNT_FIRST_CH,
          points: process.env.REACT_APP_POINTS_FIRST_CH,
        },
        {
          id: process.env.REACT_APP_PRICE_POINTS_SECOND_CH,
          amount: process.env.REACT_APP_AMOUNT_SECOND_CH,
          points: process.env.REACT_APP_POINTS_SECOND_CH,
        },
        {
          id: process.env.REACT_APP_PRICE_POINTS_THIRD_CH,
          amount: process.env.REACT_APP_AMOUNT_THIRD_CH,
          points: process.env.REACT_APP_POINTS_THIRD_CH,
        },
      ]
    : [
        {
          id: process.env.REACT_APP_PRICE_POINTS_FIRST,
          amount: process.env.REACT_APP_AMOUNT_FIRST,
          points: process.env.REACT_APP_POINTS_FIRST,
        },
        {
          id: process.env.REACT_APP_PRICE_POINTS_SECOND,
          amount: process.env.REACT_APP_AMOUNT_SECOND,
          points: process.env.REACT_APP_POINTS_SECOND,
        },
        {
          id: process.env.REACT_APP_PRICE_POINTS_THIRD,
          amount: process.env.REACT_APP_AMOUNT_THIRD,
          points: process.env.REACT_APP_POINTS_THIRD,
        },
      ]
